export default "__VITE_ASSET__1V17z2zo__"